import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useNavigate, useLocation } from "react-router-dom";
import { BiSolidEditAlt } from "react-icons/bi";
import { FaSearch } from "react-icons/fa";
import moment from "moment";
import Loading from "../../Components/Loading";

function ListofOrdersNotStarted({ division, department }) {
  const [isloading, setisloading] = useState(false);
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const [listOfOrders, setlistOfOrders] = useState([]);
  const userState = useSelector((state) => state.changeTheState.user);
  const userName = userState?.emailId?.split("@")[0].toUpperCase();
  const [search, setSearch] = useState("");
  const [popup, setPopUp] = useState(false);
  const [itemsList, setItemsList] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState({});
  const [popupLoad, setPopUpLoad] = useState(false);
  const divisionState = useSelector((state) => state.changeDivision);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [tablesList, setTablesList] = useState([]);
  const [selTable, setSelTable] = useState("");
  const [waiterList, setWaiterList] = useState([]);
  const [selWaiter, setSelWaiter] = useState("");
  const [prodList, setProdList] = useState([]);
  const [selProduct, setSelProduct] = useState("");
  const [subCatList, setSubCatList] = useState([]);
  const [selSubCat, setSelSubCat] = useState("");

  // Filter
  const filtOrders = listOfOrders.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);
    if (
      searchData.length === 0 &&
      !selProduct &&
      !selSubCat &&
      !selTable &&
      !selWaiter
    ) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "BILLNO",
        "TABLENO",
        "SUBCATEGORY",
        "PRODUCT",
        "WAITER",
        "PRODUCTCODE",
        "CLIENT",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const tableMatch =
      !selTable || selTable.toLowerCase() === item?.TABLENO?.toLowerCase();

    const waiterMatch =
      !selWaiter || selWaiter.toLowerCase() === item?.WAITER?.toLowerCase();

    const prodMatch =
      !selProduct || selProduct.toLowerCase() === item?.PRODUCT?.toLowerCase();

    const subcatMatch =
      !selSubCat ||
      selSubCat.toLowerCase() === item?.SUBCATEGORY?.toLowerCase();

    return textMatch && prodMatch && subcatMatch && tableMatch && waiterMatch;
  });

  // useEffect(() => {
  //   if (division || divisionState) {
  //     getOrderStatus();
  //   }
  // }, [division, divisionState]);

  useEffect(() => {
    if (department) {
      getOrderStatus();
    }
  }, [department, division]);

  const getOrderStatus = () => {
    setisloading(true);
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1742&DIVISION=${divisionState}&DEPARTMENT=${department}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        const filter = response.data.filter(
          (item) => item.STATUS === "NOT STARTED",
        );
        setlistOfOrders(filter);
        const uniqueWaiter = [
          ...new Map(filter?.map((item) => [item.WAITER, item])).values(),
        ];
        setWaiterList(uniqueWaiter);
        const uniqueTable = [
          ...new Map(filter?.map((item) => [item.TABLENO, item])).values(),
        ];
        setTablesList(uniqueTable);
        const uniqueSubCat = [
          ...new Map(filter?.map((item) => [item.SUBCATEGORY, item])).values(),
        ];
        setSubCatList(uniqueSubCat);
        const uniqueProds = [
          ...new Map(filter?.map((item) => [item.PRODUCT, item])).values(),
        ];
        setProdList(uniqueProds);

        setisloading(false);
      })
      .catch((error) => {
        console.error(
          "Error fetching List Of Project Idss /getOrderStatus:",
          error,
        );
      });
  };

  // ******************* Save ********************************
  async function UpdateStatus() {
    try {
      const results = await Promise.allSettled(
        selectedOrders.map((row) =>
          axios.post(
            `${BASEURL_GLOBAL}/globalSpHandler?spname=1765`,
            {
              CASHSALENO: Number(row.BILLNO),
              ITEMCODE: row.PRODUCTCODE || "",
              STATUS: "STARTED",
              SUCCESS_STATUS: "",
              ERROR_STATUS: "",
            },
            {
              headers: {
                "auth-token": authToken,
                "session-token": sessiontoken,
              },
            },
          ),
        ),
      );

      const failed = results.filter(
        (result) => result.status === "rejected" || result.value.status !== 201,
      );

      if (failed.length === 0) {
        alert(`Status Updated successfully`);
        window.location.reload();
      } else {
        failed.forEach((result) => {
          if (result.status === "rejected") {
            console.error(
              "Error while Updating one or more Status",
              result.reason,
            );
          } else {
            console.error(
              "Error while Updating one or more Status",
              result.value.data,
            );
          }
        });
        const firstErrorMessage =
          failed[0].status === "rejected"
            ? failed[0].reason?.response?.data?.message
            : failed[0].value?.data?.message;
        alert(firstErrorMessage || "Some Status failed to update");
        setisloading(false);
      }
    } catch (error) {
      console.log(error);
      alert(error?.response?.data?.message);
      setisloading(false);
      console.error(`Error while Updating Status`, error);
    }
  }

  // const handleSelectOrder = (item, checked) => {
  //   if (checked) {
  //     setSelectedOrders((prev) => [...prev, item]);
  //   } else {
  //     setSelectedOrders((prev) =>
  //       prev.filter(
  //         (selectedItem) =>
  //           selectedItem.BILLNO !== item.BILLNO ||
  //           selectedItem.PRODUCTCODE !== item.PRODUCTCODE,
  //       ),
  //     );
  //   }
  // };


  const handleSelectOrder = (item, checked) => {
  const lineCode = String(item?.PRODUCTCODE || "").trim();

  const hasAddon =
    String(item?.HASADDON || "")
      .trim()
      .toUpperCase() === "YES";

  if (checked) {
    setSelectedOrders((prev) => {
      // Avoid duplicate selections
      const existing = prev.filter(
        (selectedItem) =>
          selectedItem.BILLNO === item.BILLNO &&
          selectedItem.PRODUCTCODE === item.PRODUCTCODE
      );

      // If already selected, don't add again
      if (existing.length > 0) {
        return prev;
      }

      // Select the main product
      const rowsToSelect = [item];

      // If selected product HASADDON = YES,
      // automatically select its addon products
      if (hasAddon) {
        const addonRows = filtOrders.filter((row) => {
          const isAddon =
            String(row?.ADDONPRODUCT || "")
              .trim()
              .toUpperCase() === "YES";

          const mainProduct = String(row?.MAINPRODUCT || "").trim();

          return (
            isAddon &&
            mainProduct === lineCode &&
            row.BILLNO === item.BILLNO
          );
        });

        rowsToSelect.push(...addonRows);
      }

      // Add only rows that are not already selected
      const newRows = rowsToSelect.filter(
        (row) =>
          !prev.some(
            (selectedItem) =>
              selectedItem.BILLNO === row.BILLNO &&
              selectedItem.PRODUCTCODE === row.PRODUCTCODE
          )
      );

      return [...prev, ...newRows];
    });
  } else {
    setSelectedOrders((prev) => {
      // Remove the selected product
      // and its addon products when the main product is unchecked
      if (hasAddon) {
        return prev.filter((selectedItem) => {
          const isAddon =
            String(selectedItem?.ADDONPRODUCT || "")
              .trim()
              .toUpperCase() === "YES";

          const mainProduct = String(
            selectedItem?.MAINPRODUCT || ""
          ).trim();

          const isRelatedAddon =
            isAddon &&
            mainProduct === lineCode &&
            selectedItem.BILLNO === item.BILLNO;

          const isMainProduct =
            selectedItem.BILLNO === item.BILLNO &&
            selectedItem.PRODUCTCODE === item.PRODUCTCODE;

          return !isMainProduct && !isRelatedAddon;
        });
      }

      return prev.filter(
        (selectedItem) =>
          selectedItem.BILLNO !== item.BILLNO ||
          selectedItem.PRODUCTCODE !== item.PRODUCTCODE
      );
    });
  }
};


  const handleSelectAll = (checked) => {
    setSelectAll(checked);

    if (checked) {
      setSelectedOrders(filtOrders);
    } else {
      setSelectedOrders([]);
    }
  };

  if (isloading) {
    return <Loading />;
  }
  return (
    <div>
      {/* <KitchenAllPagesNavbar /> */}
      {/* Table Details */}
      <div className="flex gap-1">
        <p className="text-red-600">Waiter :</p>
        <Select
          className="w-64"
          onChange={(e) => {
            setSelWaiter(e.value);
          }}
          value={
            selWaiter
              ? { label: selWaiter, value: selWaiter }
              : { label: "", value: "" }
          }
          options={[
            { value: "", label: "All" },
            ...waiterList.map((item) => ({
              label: item.WAITER,
              value: item.WAITER,
            })),
          ]}
        />
        <p className="text-red-600">Table No:</p>
        <Select
          className="w-64"
          onChange={(e) => {
            setSelTable(e.value);
          }}
          value={
            selTable
              ? { label: selTable, value: selTable }
              : { label: "", value: "" }
          }
          options={[
            { value: "", label: "All" },
            ...tablesList.map((item) => ({
              label: item.TABLENO,
              value: item.TABLENO,
            })),
          ]}
        />
        <p className="text-red-600">Sub Category:</p>
        <Select
          className="w-64"
          onChange={(e) => {
            setSelSubCat(e.value);
          }}
          value={
            selSubCat
              ? { label: selSubCat, value: selSubCat }
              : { label: "", value: "" }
          }
          options={[
            { value: "", label: "All" },
            ...subCatList.map((item) => ({
              label: item.SUBCATEGORY,
              value: item.SUBCATEGORY,
            })),
          ]}
        />
        <p className="text-red-600">Product :</p>
        <Select
          className="w-64"
          onChange={(e) => {
            setSelProduct(e.value);
          }}
          value={
            selProduct
              ? { label: selProduct, value: selProduct }
              : { label: "", value: "" }
          }
          options={[
            { value: "", label: "All" },
            ...prodList.map((item) => ({
              label: item.PRODUCT,
              value: item.PRODUCT,
            })),
          ]}
        />
      </div>

      <div className="overflow-y-auto overflow-x-hidden h-80 shadow-lg">
        <div className="table__pos__app lg:w-[550px]">
          <div className="flex gap-2 justify-end">
            <input
              className="w-4 h-4"
              type="checkbox"
              checked={selectAll}
              onChange={(e) => handleSelectAll(e.target.checked)}
            ></input>
            <p className="">Select All</p>
            <button
              className="flex items-center justify-center h-8 border border-black bg-[#002d62] text-white rounded-md px-4 mr-2 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                if (selectedOrders?.length > 0) {
                  await UpdateStatus();
                } else {
                  alert("Kindly select rows to update");
                }
              }}
            >
              Update Status
            </button>
          </div>
          <table className="w-full border-collapse text-[11px] font-normal">
            <thead>
              <tr className="bg-slate-700 text-white">
                <th className="h-8 border-r border-slate-500 px-3 py-1 text-left font-medium whitespace-nowrap">
                  S NO
                </th>

                <th className="h-8 border-r border-slate-500 px-3 py-1 text-left font-medium whitespace-nowrap">
                  BILL NO
                </th>

                <th className="h-8 border-r border-slate-500 px-3 py-1 text-left font-medium whitespace-nowrap">
                  TABLE NO
                </th>

                <th className="h-8 border-r border-slate-500 px-3 py-1 text-left font-medium whitespace-nowrap">
                  PRODUCT CODE
                </th>

                <th className="h-8 border-r border-slate-500 px-3 py-1 text-left font-medium whitespace-nowrap">
                  PRODUCT
                </th>

                <th className="h-8 border-r border-slate-500 px-3 py-1 text-right font-medium whitespace-nowrap">
                  QTY
                </th>

                <th className="h-8 border-r border-slate-500 px-3 py-1 text-left font-medium whitespace-nowrap">
                  NARRATION
                </th>
                <th className="h-8 border-r border-slate-500 px-3 py-1 text-left font-medium whitespace-nowrap">
                  STATUS
                </th>

                <th className="h-8 px-3 py-1 text-center font-medium whitespace-nowrap">
                  SELECT
                </th>
              </tr>
            </thead>

            <tbody>
              {filtOrders.map((item, index) => {
                const isSelected = selectedOrders.some(
                  (selectedItem) =>
                    selectedItem.BILLNO === item.BILLNO &&
                    selectedItem.PRODUCTCODE === item.PRODUCTCODE,
                );

                const hasAddon =
                  String(item.HASADDON || "")
                    .trim()
                    .toUpperCase() === "YES";

                return (
                  <tr
                    key={index}
                    className={`
              h-8
              border-b border-gray-300
              ${hasAddon ? "bg-green-400" : "bg-white"}
              hover:bg-gray-100
            `}
                  >
                    <td className="border-r border-gray-300 px-3 py-1 text-right whitespace-nowrap">
                      {index + 1}
                    </td>

                    <td className="border-r border-gray-300 px-3 py-1 text-right whitespace-nowrap">
                      {item.BILLNO}
                    </td>

                    <td className="border-r border-gray-300 px-3 py-1 whitespace-nowrap">
                      {item.TABLENO}
                    </td>

                    <td className="border-r border-gray-300 px-3 py-1 whitespace-nowrap">
                      {item.PRODUCTCODE}
                    </td>

                    <td className="border-r border-gray-300 px-3 py-1 whitespace-nowrap">
                      {item.PRODUCT}
                    </td>

                    <td className="border-r border-gray-300 px-3 py-1 text-right whitespace-nowrap">
                      {item.QTY}
                    </td>

                    <td className="border-r border-gray-300 px-3 py-1 whitespace-nowrap">
                      {item.NARRATION || ""}
                    </td>
                    <td className="border-r border-gray-300 px-3 py-1 whitespace-nowrap">
                      {item.STATUS || ""}
                    </td>

                    <td className="px-3 py-1 text-center">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={(e) =>
                          handleSelectOrder(item, e.target.checked)
                        }
                        className="h-3.5 w-3.5 cursor-pointer accent-slate-600"
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ListofOrdersNotStarted;
